import { SequenceMenu, SequenceMenuDivider } from '@sequencehq/core-components'
import { useSetAtom } from 'jotai'
import { deleteDiscountAtom } from '../../atoms/reviewPricing.atoms'
import { taskDrawerConfigAtom } from '../../../../../atoms'

export const DiscountKebabMenu = (props: {
  phaseId: string
  discountId: string
  'data-testid'?: string
}) => {
  const deleteDiscount = useSetAtom(deleteDiscountAtom)
  const setDrawer = useSetAtom(taskDrawerConfigAtom)

  return (
    <SequenceMenu
      variant="ghost"
      buttonSize="small"
      alignment="bottom-right"
      data-testid={props['data-testid']}
      items={[
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="editDiscount"
            uuid="edit-discount"
            label="Edit discount"
            data-testid={props['data-testid'] && `${props['data-testid']}.edit`}
            onClick={() => {
              setDrawer({
                type: 'DISCOUNT',
                phaseId: props.phaseId,
                discountId: props.discountId
              })
              setIsOpen?.(false)
            }}
          />
        ),
        <SequenceMenuDivider key="divider" />,
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="removeDiscount"
            uuid="remove-discount"
            label="Remove discount"
            data-testid={
              props['data-testid'] && `${props['data-testid']}.deleteDiscount`
            }
            onClick={() => {
              deleteDiscount({
                phaseId: props.phaseId,
                discountId: props.discountId
              })
              setIsOpen?.(false)
            }}
            destructive
          />
        )
      ]}
    />
  )
}
